import { Component, OnDestroy, OnInit } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { getBrokersList, getFareShitDaysAsObject, getShiftDays } from 'src/app/utils/utils.common';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { DynamicFareServiceService } from '../dynamic-fare-service/dynamic-fare-service.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as _ from 'underscore';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';

@Component({
  selector: 'app-dynamic-fare-list',
  templateUrl: './dynamic-fare-list.component.html',
  styleUrls: ['./dynamic-fare-list.component.css']
})
export class DynamicFareListComponent implements OnInit, OnDestroy {
  dynamicfaresList = [];
  search;
  user;
  selectedCorporate = [];
  corporateList = [];
  filteredFaresList = [];
  status = "active";
  daysList = getFareShitDaysAsObject();
  preCooperates = {};
  filteredCorporates = [];
  
  constructor(
    private corporateService : CorporateService,
    public authService: AuthService,
    private dynamicFareService: DynamicFareServiceService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.getUser();
    this.getDynamicFareList();
    this.getCorporate();
    
  }

  onCorporateChange() {
    this.filteredFaresList = this.dynamicfaresList.filter(fare => {

      let isCooperateExists = true;

      if (fare.cooperate && this.selectedCorporate && this.selectedCorporate.length) {
        const isExist = this.selectedCorporate.find(sId => sId === fare.cooperate._id);

          if (isExist) {
            isCooperateExists = true;
          } else {
            isCooperateExists = false;
        }
      }
      if (isCooperateExists) {
        return true;
      } else {
        return false;
      }
    }
    );

  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data;
        }
      });
  }

  getDynamicFareList() {
    let queryParams = {
      status: this.status
    }
    this.corporateList = [];
    this.selectedCorporate = [];
    this.dynamicFareService
      .getDynamicFareList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dynamicfaresList = data;
          this.filteredFaresList = this.dynamicfaresList; // Initially show all fares
          
          for (let fare of this.dynamicfaresList) {
            if (fare.cooperate) {
              this.corporateList.push(fare.cooperate);
            }
          }

          this.corporateList = _.uniq(this.corporateList, '_id').sort();

        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  getBroker(broker){
    return getBrokersList[broker]
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data ) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  onChangeStatus() {
    this.getDynamicFareList();
  }

  ngOnDestroy(): void {
  }
}
